import { ON_VEHICLE_INFO_UPDATED, FLYOUT_CLICKED, ON_RESET_VEHICLE_INFO, ON_VEHICLE_RESOLVED, SELECTION_METHOD_CHANGED } from '../actions';
export function vehicleResolved(state = false, action) {
    switch (action.type) {
        case SELECTION_METHOD_CHANGED:
        case FLYOUT_CLICKED:
        case ON_RESET_VEHICLE_INFO:
        case ON_VEHICLE_INFO_UPDATED:
            return false;
        case ON_VEHICLE_RESOLVED:
            return true;
        default:
            return state;
    }
}
//# sourceMappingURL=vehicleResolved.js.map